import './BracketLayout.css';
import React from 'react';

import useMediaQuery from '@hooks/useMediaQuery';
import BracketGrid from '@views/BracketGrid';
import BracketMobile from '@views/BracketMobile';

import BracketPodium from '@views/BracketPodium';

const BracketLayout = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div>
      {isMobile ? (
        <div className="container matches">
          <BracketMobile />
        </div>
      ) : (
        <div className="container matches bracket-layout--grid">
          <BracketGrid />
        </div>
      )}
      <div className="container top3">
        <BracketPodium />
      </div>
    </div>
  );
};

BracketLayout.displayName = 'BracketLayout';

export default BracketLayout;
